import { Component, OnInit, Input } from '@angular/core';
import { Meta } from 'src/app/_models/meta';

@Component({
  selector: 'app-meta-list-expanded',
  standalone: false,
  templateUrl: './meta-list-expanded.component.html',
  styleUrls: ['./meta-list-expanded.component.scss']
})
export class MetaListExpandedComponent implements OnInit {

  @Input()
  meta: Meta;

  @Input()
  expanded: boolean;

  constructor() { }

  ngOnInit() {
  }

}
